import { isGetHook, isMutatorHook, isStore } from "./client.js";
import { createAsyncIteratorFromCallback } from "../util/async.js";

//#region src/client/vanilla.ts
function createVanillaListeners(hook) {
	return ({ path, query } = {}) => {
		const store = hook.store({
			path,
			query
		});
		return {
			listen: (callback) => {
				return store.listen(({ loading, error, data }) => callback({
					loading,
					error,
					data
				}));
			},
			subscribe: (callback) => {
				return store.subscribe(({ loading, error, data }) => callback({
					loading,
					error,
					data
				}));
			},
			refetch: () => {
				return store.revalidate();
			},
			get: () => {
				return store.get();
			},
			[Symbol.asyncIterator]() {
				return createAsyncIteratorFromCallback((callback) => store.listen(({ loading, error, data }) => callback({
					loading,
					error,
					data
				})));
			}
		};
	};
}
function createVanillaMutator(hook) {
	return () => {
		const store = hook.mutatorStore;
		return {
			subscribe: (callback) => {
				return store.subscribe((value) => {
					callback({
						loading: value.loading ?? false,
						error: value.error,
						data: value.data
					});
				});
			},
			get: () => {
				const { loading, error, data } = store.get();
				return {
					loading: loading ?? false,
					error,
					data
				};
			},
			mutate: ({ body, path, query }) => {
				return store.mutate({
					body,
					path,
					query
				});
			},
			[Symbol.asyncIterator]() {
				return createAsyncIteratorFromCallback((callback) => store.listen((value) => {
					callback({
						loading: value.loading ?? false,
						error: value.error,
						data: value.data
					});
				}));
			}
		};
	};
}
const getStoreDisposer = (value) => {
	const disposer = value[Symbol.dispose];
	return typeof disposer === "function" ? disposer.bind(value) : void 0;
};
function createVanillaStore(hook) {
	if ("obj" in hook) return hook.obj;
	return ((...args) => {
		const value = hook.factory(...args);
		const disposer = getStoreDisposer(value);
		if (!disposer) return value;
		Object.defineProperty(value, "destroy", {
			value: disposer,
			enumerable: false,
			configurable: true,
			writable: true
		});
		return value;
	});
}
function useFragno(clientObj) {
	const result = {};
	for (const key in clientObj) {
		if (!Object.prototype.hasOwnProperty.call(clientObj, key)) continue;
		const hook = clientObj[key];
		if (isGetHook(hook)) result[key] = createVanillaListeners(hook);
		else if (isMutatorHook(hook)) result[key] = createVanillaMutator(hook);
		else if (isStore(hook)) result[key] = createVanillaStore(hook);
		else result[key] = hook;
	}
	return result;
}

//#endregion
export { useFragno };
//# sourceMappingURL=vanilla.js.map